import _classCallCheck from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { Parser } from "../Parser.js";
import { parseAnyDigitsSigned } from "../utils.js";
export var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);

  var _super = _createSuper(TimestampMillisecondsParser);

  function TimestampMillisecondsParser() {
    var _this;

    _classCallCheck(this, TimestampMillisecondsParser);

    _this = _super.apply(this, arguments);

    _defineProperty(_assertThisInitialized(_this), "priority", 20);

    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampMillisecondsParser;
}(Parser);